import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import ItemImageTextStandard from '~/components/cms/custom/ItemImageText/ItemImageTextStandard.vue';
import ItemImageTextStandardWithoutTwicPics from '~/components/cms/custom/ItemImageText/ItemImageTextStandardWithoutTwicPics.vue';


export default {
  __name: 'KeyBenefits',
  props: {
  benefits: {
    type: Array,
    default: () => [],
  },
  useTwicPics: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const itemComponent = props.useTwicPics ? ItemImageTextStandard : ItemImageTextStandardWithoutTwicPics;

return { __sfc: true,props, itemComponent, NativeCarousel }
}

}